import { render, staticRenderFns } from "./EntryMessageReservationReservedToApplicant.vue?vue&type=template&id=213ed4bb"
import script from "./EntryMessageReservationReservedToApplicant.vue?vue&type=script&lang=js"
export * from "./EntryMessageReservationReservedToApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports